module.exports = __webpack_public_path__ + "img/jiaoyu1.81ca035a.png";